// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"oy-z","expressButtonContainerWithPayPal":"py-z","expressButton":"qy-z","or":"ry-z"};